import { __decorate } from "tslib";
import { InputDropdownInstruction, InputMultilistboxInstruction, LayoutPanelInstruction } from '@common/instructions/frontend-shared';
import { provideFeatureAddonRoutes, provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import { VirtualPropertyHelper } from '@core/shared/virtual-properties';
import { CourseItem, MandatoryCourseGroupItem } from '@mpf/courses/shared';
import * as i0 from "@angular/core";
let MpfCoursesAdminFeature = /*#__PURE__*/(() => {
  let MpfCoursesAdminFeature = class MpfCoursesAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@mpf/courses/frontend-admin","featureId":"mpf-courses"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Kurse',
          priority: 8,
          routerLink: 'courses',
          icon: 'film',
          items: [{
            label: 'Kurse',
            routerLink: 'courses/courses'
          }, {
            label: 'Kategorien',
            routerLink: 'courses/categories'
          },
          // {label:'Prüfungen',routerLink:'courses/exams'},
          {
            label: 'Prüfungszulassungen',
            routerLink: 'courses/admissions'
          }, {
            label: 'User Statusabfrage',
            routerLink: 'courses/user-inspect'
          }]
        }, {
          displayInGroup: 'statistics',
          routerLink: 'statistics/exams',
          label: 'Prüfungen',
          icon: 'chalkboard'
        }, {
          displayInGroup: 'statistics',
          routerLink: 'statistics/exams/score',
          label: 'Prüfungsergebnisse',
          icon: 'graduation-cap'
        }]
      });
      functionality.defineModelInstructions([{
        modelId: 'UserItem',
        displayContext: ['admin', 'crud'],
        // displayForEditorDefinitions:['admin'],
        displayInEditModes: ['edit'],
        targetSlotId: 'sidebar',
        instructions: [
        // Management area currently uses custom editor.
        // also the required conditional display logic does not exist yet.
        new LayoutPanelInstruction({
          title: 'Pflichtkurs-Einstellungen',
          toggleable: true,
          instructions: [new InputDropdownInstruction({
            formControlName: VirtualPropertyHelper.accessor('mandatoryCourseGroup'),
            label: 'Pflichtkurs-Gruppe',
            orientation: 'vertical',
            showClear: true,
            dropdownPlaceholder: '[Keine gewählt]',
            conditional: {
              display: model => !!model.companyId
            },
            optionsDynamic: model => {
              if (!model.companyId) return null;
              return {
                model: MandatoryCourseGroupItem,
                useCrudEndpoint: 'admin',
                filter: [{
                  field: 'companyId',
                  value: model.companyId,
                  operator: 'eq'
                }]
              };
            },
            optionValue: 'id'
          }), new InputMultilistboxInstruction({
            showToggleAll: true,
            formControlName: VirtualPropertyHelper.accessor('mandatoryCourses'),
            label: 'Pflichtkurse (manuelle Auswahl)',
            orientation: 'vertical',
            optionsGroupedBy: {
              groupProp: 'category',
              groupDataKey: 'id',
              groupOrdering: {
                field: 'ordering',
                direction: 'ASC'
              }
            },
            optionsDynamic: {
              model: CourseItem,
              useCrudEndpoint: 'public',
              queryParams: {
                withExamOrCertificate: '1'
              }
            },
            optionValue: 'id',
            conditional: {
              display: model => {
                return !VirtualPropertyHelper.get(model, 'mandatoryCourseGroup');
              }
            }
          })]
        })]
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMpfCoursesAdminFeature_BaseFactory;
        return function MpfCoursesAdminFeature_Factory(__ngFactoryType__) {
          return (ɵMpfCoursesAdminFeature_BaseFactory || (ɵMpfCoursesAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MpfCoursesAdminFeature)))(__ngFactoryType__ || MpfCoursesAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MpfCoursesAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'courses',
          loadChildren: () => import('./courses-admin.module').then(m => m.CoursesAdminModule)
        }]), provideFeatureAddonRoutes([{
          useAddonSlot: 'statistics',
          path: 'exams',
          loadChildren: () => import('./statistics/exams/exams-statistics.module').then(m => m.ExamsStatisticsAdminModule)
        }])]
      });
    }
  };
  MpfCoursesAdminFeature = __decorate([ClassName("MpfCoursesAdminFeature")], MpfCoursesAdminFeature);
  return MpfCoursesAdminFeature;
})();
export { MpfCoursesAdminFeature };